import { VendorUserRoles } from 'venminder-default/shared/enums/vendor-user-roles';

export function getRequiredVenminderRoles(): VendorUserRoles[] {
    return [VendorUserRoles.DCAdmin_Area_Billing];
}
